module.exports = __webpack_public_path__ + "img/2473.869ba88e.jpg";